import React, { Component } from "react";
import classNames from "classnames";
import "../styles/skillsMenu.css";
import frontendIcon from "../assets/eagle-emblem.png";
import backendIcon from "../assets/hawk-emblem.png";
import blogImage from "../assets/blog-preview.jpg"; // Add an image for the blog
import merchImage from "../assets/merch-preview.jpg"; // Add an image for the merch

export default class SkillsMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeMenuItem: 1,
    };
  }

  handleMenuItemClick = (menuItem) => {
    this.setState({
      activeMenuItem: menuItem,
    });
  };

  renderContent = () => {
    return (
      <div className="image-container">
        {this.state.activeMenuItem === 1 ? (
          <img src={blogImage} alt="Blog Website Preview" className="content-image" />
        ) : (
          <img src={merchImage} alt="Merch Website Preview" className="content-image" />
        )}
      </div>
    );
  };

  render() {
    const { activeMenuItem } = this.state;
    const menuItems = ["BLOG", "MERCH"];

    const currentIcon = activeMenuItem === 1 ? frontendIcon : backendIcon;

    return (
      <div className="skill-menu">
        {menuItems.map((item, index) => (
          <div
            key={index}
            className={classNames("skill-item", {
              activeSkill: activeMenuItem === index + 1,
            })}
            onClick={() => this.handleMenuItemClick(index + 1)}
          >
            <h2 className="skill-title">{item}</h2>
          </div>
        ))}
        <img className="skill-icon" src={currentIcon} alt="current section icon" />
        <div className="skill-sub-container">{this.renderContent()}</div>
      </div>
    );
  }
}
